import WeeklyGraphs from './WeeklyGraphs';

export default WeeklyGraphs;
